import { PayloadModel } from "@/services/http/payloadModel";

export interface SetCredentialsPayloadInterface {
  password: string;
  recoveryQuestion: string;
  recoveryQuestionAnswer: string;
}

export class SetCredentialsPayload
  implements
    SetCredentialsPayloadInterface,
    PayloadModel<SetCredentialsPayloadInterface>
{
  constructor(
    public password: string,
    public recoveryQuestion: string,
    public recoveryQuestionAnswer: string
  ) {}

  getPayload(): SetCredentialsPayloadInterface {
    return {
      password: this.password,
      recoveryQuestion: this.recoveryQuestion,
      recoveryQuestionAnswer: this.recoveryQuestionAnswer,
    };
  }
}
